function isEmptyArray(arr) {
    return !Array.isArray(arr) || !arr.length;
}

function hasUndefAge(undefValue) {
    if (typeof undefValue !== 'undefined') {
        return true;
    }

    return false;
}

function setUndefAge(undefValue) {
    let ageValue = hasUndefAge(undefValue)
        ? undefValue
        : {value: '-', label: '-', disabled: true};

    return ageValue;
}

function generateAgesArray(minVal = 0, maxVal = 17) {
    let agesArray = [];
    for (let age = minVal; age <= maxVal; age++) {
        agesArray.push({
            value: age,
            label: age.toString(),
        });
    }
    return agesArray;
}

function setAgeOptions(ageOptions) {
    const {minVal, maxVal, minAge, useUndefAges, undefAgesValue} = ageOptions || {};
    const agesArray = generateAgesArray(minVal, maxVal);
    if (minAge || useUndefAges) {
        let newOptions = [];
        agesArray.map((option, i) => {
            let newOption = {};
            newOption = {...option};

            if (minAge && minAge > i) {
                newOption.disabled = true;
            }

            newOptions.push(newOption);
        });

        if (useUndefAges) {
            newOptions.unshift(setUndefAge(undefAgesValue));
        }

        return newOptions;
    }
    return agesArray;
}

export {isEmptyArray, setAgeOptions};